import { client } from '@api/client';

import { IText } from '@interfaces/common/common';
import {
	ILatestConfigFileViewDTO,
	IPreviewConfigFileDTO,
	IUpdateGNodeBConfigParametersDTO,
} from '@interfaces/crowdcell/dto/gNodeBConfigDTO';
import {
	IDefaultGNodeBConfigParameters,
	IGNodeBConfigParameters,
} from '@interfaces/crowdcell/gNodeBConfig';

import { EGNodeBParametersTypes, TGNodeBConfigParameters } from '@enums/crowdCells';

import { URL } from './urls';

const { crowdCells } = URL;

export const getGNodeBConfigParameters = (id: string): Promise<IGNodeBConfigParameters> => {
	return client.get(`/${crowdCells}/${id}/configs/gnodeb`);
};

export const updateGNodeBConfigParameters = (
	data: IUpdateGNodeBConfigParametersDTO,
): Promise<TGNodeBConfigParameters> => {
	return client.post(`/${crowdCells}/${data.id}/configs/gnodeb`, data);
};

export const getDefaultGNodeBConfigParameters = (
	type = EGNodeBParametersTypes.gnodeb,
): Promise<IDefaultGNodeBConfigParameters> => {
	return client.get(`/${crowdCells}/configs/${type}/default`);
};

export const getLatestConfigFileView = (data: ILatestConfigFileViewDTO): Promise<IText> => {
	return client.get(`/${crowdCells}/${data.id}/configs/${data.type}/view`);
};

export const previewConfigFile = (data: IPreviewConfigFileDTO): Promise<IText> => {
	return client.post(`/${crowdCells}/${data.id}/configs/${data.type}/preview`, data);
};
